import { InventoryStatus } from "../../types";
import { VinoDataSKU } from "../../types/vino-data-types";

const SELLABLE_INVENTORY_STATUSES: Array<InventoryStatus> = [
  "PRESELLING",
  "AVAILABLE",
];

export const isMultiVinoDataWineSKU = (sku: VinoDataSKU): boolean => {
  return sku?.skuType === "MultiWineSKU";
};

export const isSingleVinoDataWineSKU = (sku: VinoDataSKU): boolean => {
  return sku?.skuType === "SingleWineSKU";
};

export const isSellableVinoDataWineSKU = (sku: VinoDataSKU): boolean => {
  return SELLABLE_INVENTORY_STATUSES.includes(sku?.inventoryStatus);
};
